import { Box, Grid2, Typography } from "@mui/material";
import { Loading } from "../loading/loading.component";
import { ITableHeaderButton } from "../../_common/interface/buttons/iTableHeaderButton.interface";
import { StandardButton } from "../button/primary.button";

export function StandardList(params: {
    isLoading: boolean,
    children: React.ReactNode,
    label?: string,
    buttons?: Array<ITableHeaderButton>
}) {
    return (
        <Grid2 container spacing={1}>


            <Grid2 size={{ sm: 12 }}>
                <Loading isLoading={params.isLoading} />
            </Grid2>

            {(!params.isLoading && !params.children) &&
                <Grid2 size={{ sm: 12 }}>
                    <Box display="flex" alignItems="center" justifyContent="center" sx={{ p: 1, textAlign: "center" }}>
                        <Typography color="text.secondary" fontStyle="italic">
                            {params.label || "No associated items found"}
                        </Typography>
                    </Box>
                </Grid2>
            }

            {(!params.isLoading && !!params.children) && params.children}

            {(!params.isLoading && !!params.buttons && !!params.buttons.length) && params.buttons.map((m: ITableHeaderButton, i: number) =>
                <Grid2 size={{ sm: 12 }}>
                    <StandardButton
                        noBorderRadius
                        key={`${i}_header_button_${m.label}`}
                        icon={m.icon}
                        variant={m.variant}
                        onClick={m.onClick}>
                        {m.label}
                    </StandardButton>
                </Grid2>
            )}
        </Grid2>
    )
}